import {usernameRegexGen} from 'api/gen/Username';
import {t} from 'app/translations';
import {EskotValidator} from 'utils/eskot-validator';
import {Errors} from 'utils/validator';

import {LoginFormValues} from '../../types/login-form-values';

const te = t('user');
const usernameRegex = usernameRegexGen();

export const validate = (values: LoginFormValues): Errors<LoginFormValues> => {
    const validator = new EskotValidator(values);
    validator.pattern('username', usernameRegex, te('username'));
    validator.nonEmpty('username', te('username'));
    validator.nonEmpty('password', te('password'));

    return validator.generateErrorsObject();
};
